var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"public-api-index"},[(_vm.hasPublicApiEnabled())?_c('Box',[_c('PublicApiKeyTable')],1):_c('PublicApiForbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }